import { ByStatesResponse } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class StoreView<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description Returns an array of zones (each zone corresponds to a state) and, for each zone, the list of city/market entries with their default store and market ID.
	 *
	 * @tags StoreView
	 * @name StoreViewByStates
	 * @summary Get zones (states) and their city/market entries
	 * @request GET:/store/{storeId}/hdm/storeview/byStates
	 * @secure
	 * @response `200` `ByStatesResponse` The request completed successfully.
	 * @response `400` `void` Bad request. One or more parameters are missing or invalid.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` Forbidden. The user is not authorized to access this resource.
	 * @response `404` `void` Resource not found.
	 * @response `500` `void` Internal server error.
	 */
	storeViewByStates = (
		storeId: string,
		query: {
			/**
			 * The language identifier (for example, -5).
			 * @example "-5"
			 */
			langId: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['storeViewByStates'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/storeview/byStates`,
				params: _params,
				query: query,
				methodName: 'storeViewByStates',
			};
			logger.trace(traceData);
		}
		return this.http.request<ByStatesResponse, void>({
			path: `/store/${storeId}/hdm/storeview/byStates`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
